module.exports = __webpack_public_path__ + "img/pin-prata.6e8e0673.png";